module.exports = __webpack_public_path__ + "media/src/public/img/main-bg1-f456db389742dda4cfdf181309eff4ce.webp";